"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CustomerDetailsForm;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _formik = require("formik");
var Yup = _interopRequireWildcard(require("yup"));
var _content = require("@sart/content");
var _styles = require("@sart/styles");
var _utilities = require("@sart/utilities");
var _Label = _interopRequireDefault(require("./Label"));
var _TextInputExtended = _interopRequireDefault(require("./TextInputExtended"));
var _Space = _interopRequireDefault(require("./Space"));
var _CheckBox = _interopRequireDefault(require("./CheckBox"));
var _Button = _interopRequireDefault(require("./Button"));
var _SelectExtended = _interopRequireDefault(require("./SelectExtended"));
var _icons = require("@sart/icons");
var _client = _interopRequireDefault(require("@sart/client"));
var _reactDeviceDetect = require("react-device-detect");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // import PropTypes from 'prop-types'
// import Help from './Help.png'
var cheatsheetValues = {
  title: 'MR',
  firstName: 'Steven',
  middleName: '',
  lastName: 'Burns',
  email: 'stevenburns@separatereality.co.uk',
  phoneNumber: '0123456789',
  postcode: '55555',
  dobDay: '09',
  dobMonth: '08',
  dobYear: '1991',
  address1: '5 Elm Grove',
  address2: 'NONONO',
  city: 'Newcastle',
  county: 'Tyne and Wear',
  taxCode: '012345678912'
};
function CustomerDetailsForm(props) {
  var onFormSubmit = props.onFormSubmit,
    allowCheat = props.allowCheat,
    showMiddleName = props.showMiddleName,
    style = props.style,
    labelStyle = props.labelStyle,
    regions = props.regions,
    titleStyle = props.titleStyle,
    selectStyle = props.selectStyle,
    disabledStyle = props.disabledStyle,
    enabledStyle = props.enabledStyle,
    containerStyle = props.containerStyle,
    displayAgentCode = props.displayAgentCode,
    selectTheme = props.selectTheme,
    textInputTheme = props.textInputTheme,
    buttonTheme = props.buttonTheme,
    eSimAvailable = props.eSimAvailable;
  var showRegion = regions && regions.length > 0;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    helpPoint = _useState2[0],
    setHelpPoint = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    deliveryText = _useState4[0],
    setDeliveryText = _useState4[1];
  var content = (0, _content.useContent)();
  var existingSIM = _client["default"].cache.existingSIM;
  var navigation = props.navigation;
  var AgentFormat = new RegExp(/^[a-zA-Z]+$/); //any length only Alpha characters

  var formik = (0, _formik.useFormik)({
    enableReinitialize: true,
    initialValues: {
      title: 'MR',
      firstName: '',
      middleName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      taxCode: '',
      dobDay: '',
      dobMonth: '',
      dobYear: '',
      postcode: '',
      address1: '',
      address2: '',
      city: '',
      county: '',
      referralCode: '',
      eSIM: false,
      eSIMDevice: false,
      validDevice: false,
      termsAndConditions: false,
      privacyPolicy: false
      // ...props.initialValues
    },
    validationSchema: Yup.object().shape({
      title: Yup.string().trim().required(content.forms.required),
      firstName: Yup.string().trim().required(" ").test('first-name-check', content.register_details.noSpecialCharacters, function (value) {
        return blockSpecialCharacters(value);
      }),
      middleName: Yup.string().trim().test('middle-name-check', content.register_details.noSpecialCharacters, function (value) {
        return blockSpecialCharacters(value);
      }),
      lastName: Yup.string().trim().required(" ").test('last-name-check', content.register_details.noSpecialCharacters, function (value) {
        return blockSpecialCharacters(value);
      }),
      email: Yup.string().required(" ").test('email-check', content.forms.emailInvalidCharacters, function (value) {
        if (value) {
          return value.match(/^([a-z0-9_\-.])+@([a-z0-9_\-.])+\.([a-z])+$/);
        } else {
          return true;
        }
      }),
      phoneNumber: Yup.string().trim().required(" ").length(10, content.checkout.numberLength).test('phone number check', content.checkout.numberDigits, function (value) {
        if (value) {
          return value.match(/^\d{10}$/);
        } else {
          return true;
        }
      }),
      dobDay: Yup.string().trim().required((0, _content.formatString)(content.forms.isRequired, {
        label: content.forms.dayLabel
      })).max(2, content.register_details.dayLength).test('age check 1', content.register_details.invalidDay, function (value) {
        if (value < 1 || value > 31) {
          return false;
        }
        if (formik.values.dobMonth) {
          if (formik.values.dobMonth == 2) {
            if (formik.values.dobYear % 4 == 0 && formik.values.dobYear % 100 != 0 || formik.values.dobYear % 400 == 0) {
              if (value > 29 || value <= 0) {
                return false;
              } else {
                return true;
              }
            } else {
              if (value > 28 || value <= 0) {
                return false;
              } else {
                return true;
              }
            }
          } else if (formik.values.dobMonth == 4 || formik.values.dobMonth == 6 || formik.values.dobMonth == 9 || formik.values.dobMonth == 11) {
            if (value > 30 || value <= 0) {
              return false;
            } else {
              return true;
            }
          } else if (formik.values.dobMonth == 1 || formik.values.dobMonth == 3 || formik.values.dobMonth == 5 || formik.values.dobMonth == 7 || formik.values.dobMonth == 8 || formik.values.dobMonth == 10 || formik.values.dobMonth == 12) {
            if (value > 31 || value <= 0) {
              return false;
            } else {
              return true;
            }
          } else {
            return true;
          }
        } else {
          return true;
        }
      }),
      dobMonth: Yup.string().trim().required((0, _content.formatString)(content.forms.isRequired, {
        label: content.forms.monthLabel
      })).max(2, content.register_details.monthLength).test('age check 2', content.register_details.invalidMonth, function (value) {
        if (value > 12 || value <= 0) {
          return false;
        } else {
          return true;
        }
      }),
      dobYear: Yup.string().trim().required((0, _content.formatString)(content.forms.isRequired, {
        label: content.forms.yearLabel
      })).length(4, content.register_details.yearLength).test('age check 3', content.register_details.invalidYear, function (value) {
        if (value && formik.values.dobDay && formik.values.dobMonth) {
          var dob = new Date();
          dob.setFullYear(value);
          dob.setMonth(formik.values.dobMonth - 1);
          dob.setDate(formik.values.dobDay);
          var minYear = new Date();
          minYear.setFullYear(minYear.getFullYear() - 18);
          if (dob > minYear) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      }).test('age-check-4', content.register_details.invalidYear2, function (value) {
        if (value && formik.values.dobDay && formik.values.dobMonth) {
          var dob = new Date();
          dob.setFullYear(value);
          dob.setMonth(formik.values.dobMonth - 1);
          dob.setDate(formik.values.dobDay);
          var maxYear = new Date();
          maxYear.setFullYear(maxYear.getFullYear() - 100);
          if (dob < maxYear) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      }),
      address1: Yup.string().required(" ").test('address-1-check', content.profile_address.noSpecialCharacters, function (value) {
        return validateAddress(value);
      }),
      address2: Yup.string().test('address-2-check', content.profile_address.noSpecialCharacters, function (value) {
        return validateAddress(value);
      }),
      city: Yup.string().required(" ").test('city-check', content.profile_address.noSpecialCharacters, function (value) {
        return blockSpecialCharacters(value);
      }),
      county: Yup.string().required(" ").test('county-check', content.profile_address.noSpecialCharacters, function (value) {
        return blockSpecialCharacters(value);
      }),
      postcode: Yup.string().trim().required(" ").test('postcode-check', content.profile_address.validPostcode, function (value) {
        return validatePostcode(value);
      }),
      taxCode: Yup.string().trim().notRequired().test('rfc-test', content.profile_identification.rfcValid, function (value) {
        return validateRfc(value);
      }),
      region: showRegion ? Yup.string().trim().required(" ") : Yup.string(),
      referralCode: Yup.string().test('referralCode-test', 'Invalid agent code', function (value) {
        return validateAgentCode(value);
      }),
      eSIM: Yup["boolean"](),
      eSIMDevice: Yup["boolean"]().when('eSIM', {
        is: true,
        then: Yup["boolean"]().oneOf([true], "Device must be valid")
      }),
      validDevice: Yup["boolean"]().required(content.checkout.imeiRequired).oneOf([true], content.checkout.mustBeSelected),
      termsAndConditions: Yup["boolean"]().required(content.checkout.termsAndConditionsRequired).oneOf([true], content.checkout.mustBeSelected),
      privacyPolicy: Yup["boolean"]().required(content.checkout.privacyPolicyRequired).oneOf([true], content.checkout.mustBeSelected)
    }),
    onSubmit: onFormSubmit
  });
  var _useState5 = (0, _react.useState)(formik.values.validDevice),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    validDevice = _useState6[0],
    setValidDevice = _useState6[1];
  function validateRfc(value) {
    if (!!value && !value.match(/^[A-za-z0-9]{12,13}$/)) {
      return false;
    }
    return true;
  }
  function validateAgentCode(value) {
    if (AgentFormat.test(value)) {
      //Apply as Agent referral code
      return true;
    } else {
      return false;
    }
  }
  function blockSpecialCharacters(value) {
    if (value) {
      if (value.match(/^[A-Za-zÀ-ÖØ-öø-ÿ0-9\s'-]+$/)) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  function validateAddress(value) {
    if (value) {
      if (value.match(/^[A-Za-zÀ-ÖØ-öø-ÿ0-9\s'-,.]+$/)) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  function validatePostcode(value) {
    if (value) {
      return value.match(/^\d{5}$/);
    } else {
      return true;
    }
  }
  function handleAutofillCheat() {
    formik.setValues(cheatsheetValues);
  }
  function selectTitle(option) {
    formik.setFieldValue('title', option.value);
  }
  function selectRegion(option) {
    formik.setFieldValue('region', option.value);
  }
  function handleValidDevice() {
    // setValidDevice(true)
  }
  (0, _react.useEffect)(function () {
    if (props.initialValues) {
      formik.setValues(props.initialValues);
    }
  }, [props.initialValues]);
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: containerStyle
  }, /*#__PURE__*/_react["default"].createElement(_SelectExtended["default"], (0, _extends2["default"])({
    label: content.forms.sex + "*",
    value: formik.values.title,
    placeholder: content.forms.sex,
    options: [{
      value: 'MR',
      label: content.register_details.male
    },
    // {value:'MRS',label:'Mrs'},
    // {value:'MISS',label:'Miss'},
    {
      value: 'MS',
      label: content.register_details.female
    }],
    onChange: function onChange(option) {
      return selectTitle(option);
    },
    onOptionChange: function onOptionChange(option) {
      formik.handleChange('title')(option.value);
    },
    error: formik.touched.title && formik.errors.title,
    styles: selectStyle,
    labelStyle: labelStyle
  }, _reactNative.Platform.select({
    // web: { },
    ios: selectTheme,
    android: selectTheme
  }), {
    selectId: "customerFormSex"
  })), /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"], (0, _extends2["default"])({
    label: content.forms.firstNameLabel + "*",
    value: formik.values.firstName,
    placeholder: content.forms.firstNamePlaceholder
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "given-name"
    },
    ios: {
      textContentType: "givenName"
    },
    android: {
      autoCompleteType: "name"
    }
  }), {
    onChangeText: formik.handleChange('firstName'),
    onBlur: formik.handleBlur('firstName'),
    error: formik.touched.firstName && formik.errors.firstName,
    labelStyle: labelStyle,
    style: style,
    onSubmitEditing: formik.handleSubmit
  }, _reactNative.Platform.select({
    // web: { },
    ios: textInputTheme,
    android: textInputTheme
  }), (0, _utilities.testID)("customerFormFirstName"))), showMiddleName && /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"], (0, _extends2["default"])({
    label: content.forms.middleNameLabel,
    value: formik.values.middleName,
    placeholder: content.forms.middleNamePlaceholder
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "additional-name"
    },
    ios: {
      textContentType: "middleName"
    },
    android: {
      autoCompleteType: "name"
    }
  }), {
    onChangeText: formik.handleChange('middleName'),
    onBlur: formik.handleBlur('middleName'),
    error: formik.touched.middleName && formik.errors.middleName,
    labelStyle: labelStyle,
    style: style,
    onSubmitEditing: formik.handleSubmit
  }, _reactNative.Platform.select({
    // web: { },
    ios: textInputTheme,
    android: textInputTheme
  }), (0, _utilities.testID)("customerFormMiddleName"))), /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"], (0, _extends2["default"])({
    label: content.forms.lastNameLabel + "*",
    keyboardType: "default",
    value: formik.values.lastName,
    placeholder: content.forms.lastNamePlaceholder
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "family-name"
    },
    ios: {
      textContentType: "familyName"
    },
    android: {
      autoCompleteType: "name"
    }
  }), {
    onChangeText: formik.handleChange('lastName'),
    onBlur: formik.handleBlur('lastName'),
    error: formik.touched.lastName && formik.errors.lastName,
    labelStyle: labelStyle,
    style: style,
    onSubmitEditing: formik.handleSubmit
  }, _reactNative.Platform.select({
    // web: { },
    ios: textInputTheme,
    android: textInputTheme
  }), (0, _utilities.testID)("customerFormSurname"))), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 24
  }), /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"], (0, _extends2["default"])({
    label: content.forms.vatLabel,
    value: formik.values.taxCode,
    placeholder: content.forms.vatPlaceholder,
    maxLength: 13,
    keyboardType: "default",
    onChangeText: formik.handleChange('taxCode'),
    onBlur: formik.handleBlur('taxCode'),
    error: formik.touched.taxCode && formik.errors.taxCode,
    labelStyle: labelStyle,
    style: style,
    onSubmitEditing: formik.handleSubmit
  }, _reactNative.Platform.select({
    // web: { },
    ios: textInputTheme,
    android: textInputTheme
  }), (0, _utilities.testID)("customerFormTaxCode"))), /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: labelStyle
  }, content.forms.dobLabel + "*"), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.inputWrapper
  }, /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"], (0, _extends2["default"])({
    wrapperStyle: styles.nestedInputs,
    value: formik.values.dobDay,
    maxLength: 2,
    placeholder: content.forms.dayPlaceholder,
    keyboardType: "number-pad"
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "bday-day"
    }
    // ios: { textContentType: "bday-day" },
    //android: { autoCompleteType: "bday-day" }
  }), {
    onChangeText: formik.handleChange('dobDay'),
    onBlur: formik.handleBlur('dobDay'),
    error: formik.touched.dobDay && formik.errors.dobDay,
    hideError: false,
    labelStyle: labelStyle,
    style: style,
    onSubmitEditing: formik.handleSubmit
  }, _reactNative.Platform.select({
    // web: { },
    ios: textInputTheme,
    android: textInputTheme
  }), (0, _utilities.testID)("customerFormDobDay"))), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    width: 8
  }), /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"], (0, _extends2["default"])({
    wrapperStyle: styles.nestedInputs,
    value: formik.values.dobMonth,
    maxLength: 2,
    placeholder: content.forms.monthPlaceholder,
    keyboardType: "number-pad"
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "bday-month"
    }
    // ios: { textContentType: "bday-month" },
    //android: { autoCompleteType: "bday-month" }
  }), {
    onChangeText: formik.handleChange('dobMonth'),
    onBlur: formik.handleBlur('dobMonth'),
    error: formik.touched.dobMonth && formik.errors.dobMonth,
    hideError: false,
    labelStyle: labelStyle,
    style: style,
    onSubmitEditing: formik.handleSubmit
  }, _reactNative.Platform.select({
    // web: { },
    ios: textInputTheme,
    android: textInputTheme
  }), (0, _utilities.testID)("customerFormDobMonth"))), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    width: 8
  }), /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"], (0, _extends2["default"])({
    wrapperStyle: styles.nestedInputs,
    value: formik.values.dobYear,
    maxLength: 4,
    placeholder: content.forms.yearPlaceholder,
    keyboardType: "number-pad"
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "bday-year"
    }
    // ios: { textContentType: "bday-year" },
    //android: { autoCompleteType: "bday-year" }
  }), {
    onChangeText: formik.handleChange('dobYear'),
    onBlur: formik.handleBlur('dobYear'),
    error: formik.touched.dobYear && formik.errors.dobYear,
    hideError: false,
    labelStyle: labelStyle,
    style: style,
    onSubmitEditing: formik.handleSubmit
  }, _reactNative.Platform.select({
    // web: { },
    ios: textInputTheme,
    android: textInputTheme
  }), (0, _utilities.testID)("customerFormDobYear")))), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 24
  }), /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"], (0, _extends2["default"])({
    label: content.forms.emailLabel + "*",
    value: formik.values.email,
    placeholder: content.forms.emailPlaceholder,
    keyboardType: "email-address"
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "email"
    },
    ios: {
      textContentType: "emailAddress"
    },
    android: {
      autoCompleteType: "email"
    }
  }), {
    autoCapitalize: "none",
    onChangeText: formik.handleChange('email'),
    onBlur: formik.handleBlur('email'),
    error: formik.touched.email && formik.errors.email,
    labelStyle: labelStyle,
    style: style,
    onSubmitEditing: formik.handleSubmit
  }, _reactNative.Platform.select({
    // web: { },
    ios: textInputTheme,
    android: textInputTheme
  }), (0, _utilities.testID)("customerFormEmailAddress"))), /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"], (0, _extends2["default"])({
    label: content.forms.phoneNumberLabel + "*",
    value: formik.values.phoneNumber,
    placeholder: content.forms.customerDetailsPhonePlaceholder,
    keyboardType: "phone-pad"
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "tel"
    },
    ios: {
      textContentType: "telephoneNumber"
    },
    android: {
      autoCompleteType: "tel"
    }
  }), {
    onChangeText: formik.handleChange('phoneNumber'),
    onBlur: formik.handleBlur('phoneNumber'),
    error: formik.touched.phoneNumber && formik.errors.phoneNumber,
    labelStyle: labelStyle,
    style: style,
    onSubmitEditing: formik.handleSubmit
  }, _reactNative.Platform.select({
    // web: { },
    ios: textInputTheme,
    android: textInputTheme
  }), (0, _utilities.testID)("customerFormPhoneNumber"))), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 24
  }), !existingSIM && /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: labelStyle
  }, content.forms.addressLabel, "*"), existingSIM && /*#__PURE__*/_react["default"].createElement(_reactNative.View, null, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: {
      flexDirection: 'row'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: labelStyle
  }, content.forms.addressLabelNonDelivery, "*"), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    width: 4
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, {
    style: styles.helpIcon,
    onPress: function onPress() {
      return setDeliveryText(!deliveryText);
    }
  }, /*#__PURE__*/_react["default"].createElement(_icons.HelpIcon, {
    color: _reactNative.Platform.OS === 'web' ? _styles.colors.focus : _styles.colors.white
  }))), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 4
  }), deliveryText && /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.helpPointContainer
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.helpPointText
  }, content.forms.deliveryInfo), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 4
  }))), /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"]
  // label={content.forms.address1Label}
  , (0, _extends2["default"])({
    value: formik.values.address1,
    placeholder: content.forms.address1Placeholder
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "address-line1"
    },
    ios: {
      textContentType: "streetAddressLine1"
    },
    android: {
      autoCompleteType: "street-address"
    }
  }), {
    onChangeText: formik.handleChange('address1'),
    onBlur: formik.handleBlur('address1'),
    error: formik.touched.address1 && formik.errors.address1,
    labelStyle: labelStyle,
    style: style,
    onSubmitEditing: formik.handleSubmit
  }, _reactNative.Platform.select({
    // web: { },
    ios: textInputTheme,
    android: textInputTheme
  }), {
    maxLength: 60
  }, (0, _utilities.testID)("customerFormAddress1"))), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 8
  }), /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"]
  // label={content.forms.address2Label}
  , (0, _extends2["default"])({
    value: formik.values.address2,
    placeholder: content.forms.address2Placeholder,
    onChangeText: formik.handleChange('address2'),
    onBlur: formik.handleBlur('address2'),
    error: formik.touched.address2 && formik.errors.address2,
    labelStyle: labelStyle,
    style: style,
    onSubmitEditing: formik.handleSubmit
  }, _reactNative.Platform.select({
    // web: { },
    ios: textInputTheme,
    android: textInputTheme
  }), (0, _utilities.testID)("customerFormAddress2"))), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 8
  }), /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"]
  // label={content.forms.cityLabel}
  , (0, _extends2["default"])({
    value: formik.values.city,
    placeholder: content.forms.cityPlaceholder
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "address-level2"
    },
    ios: {
      textContentType: "addressCity"
    }
    //android: { autoCompleteType: "address-level2" }
  }), {
    onChangeText: formik.handleChange('city'),
    onBlur: formik.handleBlur('city'),
    error: formik.touched.city && formik.errors.city,
    labelStyle: labelStyle,
    style: style,
    onSubmitEditing: formik.handleSubmit
  }, _reactNative.Platform.select({
    // web: { },
    ios: textInputTheme,
    android: textInputTheme
  }), (0, _utilities.testID)("customerFormAddressCity"))), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 8
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.inputWrapper
  }, /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"], (0, _extends2["default"])({
    wrapperStyle: styles.nestedInputs
    // label={content.forms.countyLabel}
    ,
    value: formik.values.county,
    placeholder: content.forms.countyPlaceholder
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "address-level11"
    },
    ios: {
      textContentType: "addressState"
    }
    //android: { autoCompleteType: "address-level11" }
  }), {
    onChangeText: formik.handleChange('county'),
    onBlur: formik.handleBlur('county'),
    error: formik.touched.county && formik.errors.county,
    labelStyle: labelStyle,
    style: style,
    onSubmitEditing: formik.handleSubmit
  }, _reactNative.Platform.select({
    // web: { },
    ios: textInputTheme,
    android: textInputTheme
  }), (0, _utilities.testID)("customerFormAddressCounty"))), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    width: 8
  }), /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"], (0, _extends2["default"])({
    wrapperStyle: styles.nestedInputs
    // label={content.forms.postcodeLabel}
    ,
    value: formik.values.postcode,
    placeholder: content.forms.postcodePlaceholder,
    autoCorrect: false
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "postal-code"
    },
    ios: {
      textContentType: "postalCode"
    },
    android: {
      autoCompleteType: "postal-code"
    }
  }), {
    maxLength: 5,
    onChangeText: formik.handleChange('postcode'),
    onBlur: formik.handleBlur('postcode'),
    error: formik.touched.postcode && formik.errors.postcode,
    labelStyle: labelStyle,
    style: style,
    onSubmitEditing: formik.handleSubmit
  }, _reactNative.Platform.select({
    // web: { },
    ios: textInputTheme,
    android: textInputTheme
  }), (0, _utilities.testID)("customerFormAddressPostalCode")))), showRegion && /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 8
  }), showRegion && /*#__PURE__*/_react["default"].createElement(_reactNative.View, null, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: {
      flexDirection: 'row'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: labelStyle
  }, content.forms.regionLabel + "*"), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    width: 4
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, {
    style: styles.helpIcon,
    onPress: function onPress() {
      return setHelpPoint(!helpPoint);
    }
  }, /*#__PURE__*/_react["default"].createElement(_icons.HelpIcon, {
    color: _reactNative.Platform.OS === 'web' ? _styles.colors.focus : _styles.colors.white
  }))), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 4
  }), helpPoint && /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.helpPointContainer
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.helpPointText
  }, content.forms.helpPoint), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 4
  })), /*#__PURE__*/_react["default"].createElement(_SelectExtended["default"]
  // label={content.forms.regionLabel + "*"}
  , (0, _extends2["default"])({
    value: formik.values.region,
    placeholder: content.forms.regionPlaceholder,
    options: regions,
    onChange: function onChange(option) {
      return selectRegion(option);
    },
    onOptionChange: function onOptionChange(option) {
      formik.handleChange('region')(option.value);
    },
    error: formik.touched.region && formik.errors.region,
    styles: selectStyle,
    labelStyle: labelStyle
  }, _reactNative.Platform.select({
    // web: { },
    ios: selectTheme,
    android: selectTheme
  }), {
    selectId: "customerFormRegion"
  }))), displayAgentCode && /*#__PURE__*/_react["default"].createElement(_reactNative.View, null, /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 24
  }), /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"], (0, _extends2["default"])({
    label: content.agent.referralCode,
    value: formik.values.referralCode,
    placeholder: content.agent.referralCode,
    onChangeText: formik.handleChange('referralCode'),
    onBlur: formik.handleBlur('referralCode'),
    error: formik.touched.referralCode && formik.errors.referralCode,
    labelStyle: labelStyle,
    style: style,
    onSubmitEditing: formik.handleSubmit
  }, _reactNative.Platform.select({
    // web: { },
    ios: textInputTheme,
    android: textInputTheme
  }), (0, _utilities.testID)("customerFormAddressRefferalCode")))), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 24
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.View, null, eSimAvailable && !_reactDeviceDetect.isMobileOnly && /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.guruContainer
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.instantlyConnect
  }, content.checkout.instantlyConnect), /*#__PURE__*/_react["default"].createElement(_icons.GuruPointing, null)), eSimAvailable && _reactDeviceDetect.isMobileOnly && _client["default"].cache.language === 'es' && /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.guruContainerMobileEs
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.instantlyConnectMobileEs
  }, content.checkout.instantlyConnect), /*#__PURE__*/_react["default"].createElement(_reactNative.View, null, /*#__PURE__*/_react["default"].createElement(_icons.GuruPointingSmall, null))), eSimAvailable && _reactDeviceDetect.isMobileOnly && _client["default"].cache.language === 'en' && /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.guruContainerMobileEn
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.instantlyConnectMobileEn
  }, content.checkout.instantlyConnectNewLine), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: {
      paddingLeft: 70
    }
  }, /*#__PURE__*/_react["default"].createElement(_icons.GuruPointingSmall, null))), eSimAvailable && [/*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.checkboxLine
  }, /*#__PURE__*/_react["default"].createElement(_CheckBox["default"], (0, _extends2["default"])({
    disabled: existingSIM !== undefined ? true : false,
    value: formik.values.eSIM
    // checked={formik.values.validDevice}
    ,
    onPress: (/*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(e) {
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return formik.setFieldValue("eSIM", !formik.values.eSIM);
            case 1:
              _context.next = 2;
              return formik.setFieldValue("eSIMDevice", false);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }())
    // containerStyle={styles.checkbox}
    ,
    webSize: 14,
    style: styles.checkbox,
    tintColors: {
      "true": _styles.colors.exisBlue,
      "false": _styles.colors.exisDarkCharcoal
    },
    checkedColor: '#1975FF',
    borderColor: '#1975FF',
    disabledBorderColor: '#767676',
    tickColor: _styles.colors.white
  }, (0, _utilities.testID)("customerFormeSIM"))), /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.checkboxText
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.asterisk
  }, "**"), " ", content.checkout.eSIM), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    width: 4
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.checkboxLink,
    onPress: function onPress() {
      return window.open('https://exis.mx/eSIM/', '_blank');
    }
  }, content.checkout.moreDetails)), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.checkboxLineIndent
  }, /*#__PURE__*/_react["default"].createElement(_CheckBox["default"], (0, _extends2["default"])({
    disabled: formik.values.eSIM ? false : true,
    value: formik.values.eSIMDevice
    // checked={formik.values.validDevice}
    ,
    onPress: (/*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(e) {
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return formik.setFieldValue("eSIMDevice", !formik.values.eSIMDevice);
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }())
    // containerStyle={styles.checkbox}
    ,
    webSize: 14,
    style: styles.checkbox,
    tintColors: {
      "true": _styles.colors.exisBlue,
      "false": _styles.colors.exisDarkCharcoal
    },
    checkedColor: '#1975FF',
    borderColor: '#1975FF',
    disabledBorderColor: '#767676',
    tickColor: _styles.colors.white
  }, (0, _utilities.testID)("customerFormeSIMDevice"))), /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: formik.values.eSIM ? styles.checkboxText : styles.checkboxTextDisabled
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: formik.values.eSIM ? styles.asterisk : styles.asteriskDisabled
  }, "**"), " ", content.checkout.eSIMCompatible), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    width: 4
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: formik.values.eSIM ? styles.checkboxLink : styles.checkboxLinkDisabled,
    onPress: function onPress() {
      return window.open('https://exis.mx/eSIM/', '_blank');
    }
  }, content.checkout.checkHere)), /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.doesntApplyStyle
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.asterisk
  }, "**"), " ", content.checkout.doesntApply)], /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.checkboxLine
  }, /*#__PURE__*/_react["default"].createElement(_CheckBox["default"], (0, _extends2["default"])({
    disabled: false,
    value: formik.values.validDevice
    // checked={formik.values.validDevice}
    ,
    onPress: function onPress() {
      return formik.setFieldValue("validDevice", !formik.values.validDevice);
    }
    // containerStyle={styles.checkbox}
    ,
    size: 28,
    style: styles.checkbox,
    tintColors: {
      "true": _styles.colors.exisBlue,
      "false": _styles.colors.exisDarkCharcoal
    },
    checkedColor: '#1975FF',
    borderColor: '#1975FF',
    disabledBorderColor: '#767676',
    webSize: 14,
    tickColor: _styles.colors.white
  }, (0, _utilities.testID)("customerFormValidDevice"))), /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.checkboxText
  }, content.checkout.validDevice), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    width: 4
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.checkboxLink,
    onPress: function onPress() {
      return _reactNative.Platform.OS == 'web' ? window.open('https://crm.altanredes.com/preactiva/checkimei_websiteone.php', '_blank') : _reactNative.Linking.openURL('https://crm.altanredes.com/preactiva/checkimei_websiteone.php');
    }
  }, content.checkout.checkHere)), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.checkboxLine
  }, /*#__PURE__*/_react["default"].createElement(_CheckBox["default"], (0, _extends2["default"])({
    disabled: false,
    value: formik.values.termsAndConditions
    // checked={formik.values.termsAndConditions}
    ,
    onPress: function onPress() {
      return formik.setFieldValue("termsAndConditions", !formik.values.termsAndConditions);
    }
    // containerStyle={styles.checkbox}
    ,
    size: 28,
    style: styles.checkbox,
    tintColors: {
      "true": _styles.colors.exisBlue,
      "false": _styles.colors.exisDarkCharcoal
    },
    checkedColor: '#1975FF',
    borderColor: '#1975FF',
    disabledBorderColor: '#767676',
    webSize: 14,
    tickColor: _styles.colors.white
  }, (0, _utilities.testID)("customerFormTsAndCs"))), /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.checkboxText
  }, content.checkout.readAndAccept), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    width: 4
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.linkFull,
    onPress: function onPress() {
      return _reactNative.Platform.OS == 'web' ? window.open('https://exis.mx/#/termsandconditions') : _reactNative.Linking.openURL('https://exis.mx/#/termsandconditions');
    }
  }, content.checkout.termsFull)), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.checkboxLine
  }, /*#__PURE__*/_react["default"].createElement(_CheckBox["default"], (0, _extends2["default"])({
    disabled: false,
    value: formik.values.privacyPolicy
    // checked={formik.values.privacyPolicy}
    ,
    onPress: function onPress() {
      return formik.setFieldValue("privacyPolicy", !formik.values.privacyPolicy);
    }
    // containerStyle={styles.checkbox}
    ,
    size: 28,
    style: styles.checkbox,
    tintColors: {
      "true": _styles.colors.exisBlue,
      "false": _styles.colors.exisDarkCharcoal
    },
    checkedColor: '#1975FF',
    borderColor: '#1975FF',
    disabledBorderColor: '#767676',
    webSize: 14,
    tickColor: _styles.colors.white
  }, (0, _utilities.testID)("customerFormPrivacy"))), /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.checkboxText
  }, content.checkout.readAndAcceptTwo), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    width: 4
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.linkFull,
    onPress: function onPress() {
      return _reactNative.Platform.OS == 'web' ? window.open('https://exis.mx/#/privacy') : _reactNative.Linking.openURL('https://exis.mx/#/privacy');
    }
  }, content.checkout.privacyFull))), /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
    title: formik.isSubmitting ? content.set_password.inProgress : content.register_details.action,
    disabled: !formik.dirty || !formik.isValid || formik.isSubmitting,
    onPress: formik.handleSubmit
  }, allowCheat && {
    onLongPress: handleAutofillCheat
  }, style && {
    style: enabledStyle,
    disabledStyle: disabledStyle
  }, {
    titleStyle: titleStyle
  }, _reactNative.Platform.select({
    web: {},
    ios: buttonTheme,
    android: buttonTheme
  }), (0, _utilities.testID)("customerFormSubmitButton"))));
}
CustomerDetailsForm.defaultProps = {
  showMiddleName: false,
  allowCheat: process.env.NODE_ENV === "development"
};
var styles = _reactNative.StyleSheet.create({
  inputWrapper: {
    flexDirection: 'row'
  },
  nestedInputs: {
    flex: 0.5
  },
  label: {
    marginBottom: 8
  },
  helpPointContainer: {},
  helpPointText: _objectSpread(_objectSpread({}, _styles.typography.demi), {}, {
    color: _reactNative.Platform.OS === 'web' ? _styles.colors.common : _styles.colors.white
  }),
  helpIcon: {
    justifyContent: 'center'
  },
  checkboxText: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    paddingLeft: 10
  }, _styles.typography.demi), {}, {
    color: _reactNative.Platform.OS == "android" || _reactNative.Platform.OS == "ios" ? _styles.colors.clear : _styles.colors.exisCharcoal
  }, _styles.adaptive.fontSize), _reactNative.Platform.select({
    android: {
      paddingTop: 6,
      fontSize: 11
    },
    ios: {
      paddingTop: 6,
      fontSize: 11
    }
  })), _reactDeviceDetect.isMobileOnly ? {
    //Mobile Only
    fontSize: 9
  } : {//Non-Mobile Only
  }),
  checkboxTextDisabled: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    paddingLeft: 10
  }, _styles.typography.demi), {}, {
    color: _styles.colors.common
  }, _styles.adaptive.fontSize), _reactNative.Platform.select({
    android: {
      paddingTop: 6,
      fontSize: 11
    },
    ios: {
      paddingTop: 6,
      fontSize: 11
    }
  })), _reactDeviceDetect.isMobileOnly ? {
    //Mobile Only
    fontSize: 9
  } : {//Non-Mobile Only
  }),
  checkboxLink: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _styles.typography.demi), {}, {
    color: _reactNative.Platform.OS == "android" || _reactNative.Platform.OS == "ios" ? _styles.colors.clear : _styles.colors.exisCharcoal,
    textDecorationLine: 'underline'
  }, _styles.adaptive.fontSize), _reactNative.Platform.select({
    android: {
      paddingTop: 6,
      fontSize: 11
    },
    ios: {
      paddingTop: 6,
      fontSize: 11
    }
  })), _reactDeviceDetect.isMobileOnly ? {
    //Mobile Only
    fontSize: 9
  } : {//Non-Mobile Only
  }),
  checkboxLinkDisabled: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _styles.typography.demi), {}, {
    color: _styles.colors.common,
    textDecorationLine: 'underline'
  }, _styles.adaptive.fontSize), _reactNative.Platform.select({
    android: {
      paddingTop: 6,
      fontSize: 11
    },
    ios: {
      paddingTop: 6,
      fontSize: 11
    }
  })), _reactDeviceDetect.isMobileOnly ? {
    //Mobile Only
    fontSize: 9
  } : {//Non-Mobile Only
  }),
  checkboxLine: {
    flexDirection: 'row',
    paddingBottom: 8
  },
  checkboxLineIndent: {
    flexDirection: 'row',
    paddingBottom: 8,
    paddingLeft: 28
  },
  linkFull: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _styles.typography.demi), {}, {
    color: _reactNative.Platform.OS == "android" || _reactNative.Platform.OS == "ios" ? _styles.colors.clear : _styles.colors.exisCharcoal,
    textDecorationLine: 'underline'
  }, _styles.adaptive.fontSize), _reactNative.Platform.select({
    android: {
      paddingTop: 6,
      fontSize: 11
    },
    ios: {
      paddingTop: 6,
      fontSize: 11
    }
  })), _reactDeviceDetect.isMobileOnly ? {
    //Mobile Only
    fontSize: 9
  } : {//Non-Mobile Only
  }),
  checkbox: {
    transform: [{
      scaleX: 1.0
    }, {
      scaleY: 1.0
    }],
    padding: 0,
    margin: 0
  },
  asterisk: {
    color: _styles.colors.exisOrange
  },
  asteriskDisabled: {
    color: '#F7AF8D'
  },
  doesntApplyStyle: _objectSpread(_objectSpread(_objectSpread({
    paddingLeft: 14,
    paddingBottom: 8,
    color: _styles.colors.exisBlue
  }, _styles.typography.demi), _styles.adaptive.fontSize), _reactDeviceDetect.isMobileOnly ? {
    //Mobile Only
    fontSize: 9
  } : {//Non-Mobile Only
  }),
  guruContainer: {
    position: 'absolute',
    right: -320,
    bottom: 100
  },
  guruContainerMobileEs: {
    position: 'absolute',
    right: -285,
    bottom: 105
  },
  guruContainerMobileEn: {
    position: 'absolute',
    right: -100,
    bottom: 100
  },
  instantlyConnect: _objectSpread(_objectSpread({}, _styles.typography.bold), {}, {
    fontSize: 20,
    color: _styles.colors.black,
    textAlign: 'center',
    paddingBottom: 16,
    width: 300
  }),
  instantlyConnectMobileEs: _objectSpread(_objectSpread({}, _styles.typography.bold), {}, {
    fontSize: 9,
    color: _styles.colors.black,
    width: 300
  }),
  instantlyConnectMobileEn: _objectSpread(_objectSpread({}, _styles.typography.bold), {}, {
    fontSize: 9,
    color: _styles.colors.black,
    width: 200,
    // backgroundColor: 'teal',
    textAlign: 'center'
  })
});